<template>
  <b-modal ref="admin-status-modal" class="modal fade" id="change_admin_status_modal" tabindex="-1" role="dialog" hide-footer :title="modalOptions.header" aria-labelledby="changeModal"
       aria-hidden="true">
    <div>
      {{ modalOptions.body }}
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closeModal">Κλείσιμο</button>
        <button type="button" class="btn btn-primary" @click.prevent="chooseStatusMethod">{{ modalOptions.text }}
        </button>
    </div>
  </b-modal>
</template>

<script>
import {HTTP} from "@/main";

export default {
  name: "ChangeAdminStatusModal",
  props: {
    selectedAdmin: Object,
    modalOptions: {
      type: Object,
    }
  },
  data() {
    return {
      toastOptions: {
        title: "Σφάλμα",
        text: "",
        variant: ""
      },
      toastVariants: {
        success: 'success',
        failure: 'danger'
      }
    }
  },
  methods: {
    closeModal: function () {
      this.$refs['admin-status-modal'].hide()
    },
    enable: function () {
      let item = this.selectedAdmin
      let afm = item.afm;

      let body = {
        'afm': afm
      };
      this.$store.dispatch('loading')
      HTTP.post("/authorization/users/activate", body).then((response) => {
        let resp = response.data;

        this.showToast(resp.message, this.toastVariants.success)
        this.closeModal()

      }).catch((e) => {
        this.showToast("Υπήρξε πρόβλημα στην αλλαγή κατάστασης του διαχειριστή", this.toastVariants.failure)
      }).finally(() => {
        this.$store.dispatch('stop_loading');
        item.blocked = false;
      });
    },
    disable: function () {
      let item = this.selectedAdmin
      let afm = item.afm;

      let body = {
        'afm': afm
      };
      this.$store.dispatch('loading')
      HTTP.post("/authorization/users/deactivate", body).then((response) => {
        let resp = response.data;

        this.showToast(resp.message, this.toastVariants.success)
        this.closeModal()

        item.blocked = true;
      }).catch((e) => {
        this.showToast("Υπήρξε πρόβλημα στην αλλαγή κατάστασης του διαχειριστή", this.toastVariants.failure)
        this.closeModal()
      }).finally(() => {
        this.$store.dispatch('stop_loading');
      });
    },
    chooseStatusMethod: function () {
      return this.modalOptions.id === "disable_modal" ? this.disable() : this.enable()
    },
    showToast: function (msg, variant) {
      this.toastOptions.text = msg
      this.toastOptions.variant = variant
      this.$emit('showToast', this.toastOptions)
    },
  }
}
</script>

<style scoped>

</style>
